import Emitter from 'event-emitter'
import { TweenMax } from 'gsap/gsap-core'

class Timer {
    constructor(){
        this.time = 0
        this.triggered = false
        this.active = false
        
        this._emitter = {}
        Emitter(this._emitter)
        this.on = this._emitter.on.bind(this._emitter)
        this.off = this._emitter.off.bind(this._emitter)
        this.reset()
        
    }

    reset(){
        this.time = 0
        this.active = false
        this.triggered = false
        TweenMax.killTweensOf(this)
        this._emitter.emit('reset')
    }

    back(){
        TweenMax.killTweensOf(this)
        TweenMax.to(this, {
            duration: 0.5,
            time: 0,
            onUpdate: () =>{ this.update() },
            onComplete: () => {
                this._emitter.emit('completed')
                // this.reset()
            }
        })
    }

    start(time){
        this.time = 0
        this.limit = time
        this.triggered = false
        this.active = true
        this._emitter.emit('start')

        TweenMax.to(this, {
            duration: this.limit,
            time: time,
            onUpdate: () =>{ this.update() },
            onComplete: () => {
                this._emitter.emit('completed')
                // this.reset()
            }
        })
    }

    update(){
        this._emitter.emit('progress', this.time/this.limit)
    }


}

const out = new Timer
export default out